export interface BetaInterestFormValues {
  name: string
  email: string
  whatsapp: string
}

export type BetaInterestErrors = Partial<Record<keyof BetaInterestFormValues, string>>

const MIN_DIGITS = 10
const MAX_DIGITS = 15
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export function validateBetaInterest(values: BetaInterestFormValues): BetaInterestErrors {
  const errors: BetaInterestErrors = {}
  if (values.name.trim().length < 2) errors.name = 'Escribe tu nombre.'

  const email = values.email.trim()
  if (!email) errors.email = 'Escribe tu correo: por ahí te avisaremos cuando tu lugar esté activo.'
  else if (!EMAIL_PATTERN.test(email)) errors.email = 'Revisa el correo: parece incompleto.'

  const whatsapp = values.whatsapp.trim()
  if (whatsapp) {
    const digits = whatsapp.replace(/\D/g, '')
    if (digits.length < MIN_DIGITS || digits.length > MAX_DIGITS) {
      errors.whatsapp = 'Escribe un número de WhatsApp válido, con código de país (ej. 0414 1234567).'
    }
  }
  return errors
}
